// extracted by css-extract-rspack-plugin
export default {"nowrap":"aJkbAyR4sHEPPK1V","marker":"tqfxBiAnxpEGUMPg","link":"qWcu3PWHbbMIVjVd","criticalTag":"kCc9BsyMBRA4RLI3"};